/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
// /* eslint-disable react/prop-types */
// /* eslint-disable no-unused-vars */
// /* eslint-disable import/no-extraneous-dependencies */


import React, { useState,useEffect } from "react";
import { MultiSelect } from "react-multi-select-component";


export default function MultiSelects(props) {
  const {options,value,onChange,hasSelectAll,width,placeholder}=props

  const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth <= 500)
  const handleWindowSizeChange = () => {
    setIsMobileDevice(window.innerWidth <= 500);
  }
  
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  return (
    <div style={ {fontSize:isMobileDevice ? "10px" : "14px",width:width ? width : "100%"}}>
      <MultiSelect
        options={options ? options : []}
        value={value && value}
        onChange={onChange}
        labelledBy="Select" // <- for accessiblity
        overrideStrings={{ "selectSomeItems": placeholder}} 
        style={{color:"red"}}
        hasSelectAll={hasSelectAll}
        // isCreatable={true}
      />
    </div>
  );
}

